module.exports = __webpack_public_path__ + "static/media/retirada.efccb1b9.png";